import { useTranslation } from 'react-i18next';
import { useProfilePicture } from '../../redux/user/profilePictures/useBulkProfilePictures';
import { resolveMediaUrl } from '../../utils/resolveMediaUrl';

// Shared avatar treatment -- real photo first, falling back to the same
// gradient-circle + uppercase-initial pattern for everyone else.
//
// Two ways to supply the photo:
// - `userId` alone: fetches it (via fetchProfilePicture/profilePictures
//   slice) -- for chrome that only has an id (sidebar, top bar).
// - `pictureUrl` (may be null): skips the fetch entirely and renders
//   whatever's passed directly -- for list contexts (group members, post
//   authors) whose API response already embeds a `profile_picture` field,
//   so 50 list rows don't turn into 50 redundant individual fetches.
const UserAvatar = ({ userId, username, pictureUrl, className = 'w-10 h-10', textClass = 'text-sm' }) => {
  const { t } = useTranslation();
  const hasExplicitPicture = pictureUrl !== undefined;
  const { url: fetchedUrl } = useProfilePicture(hasExplicitPicture ? null : userId);
  const url = hasExplicitPicture ? pictureUrl : fetchedUrl;
  const initial = (username || 'U').charAt(0).toUpperCase();

  if (url) {
    return (
      <img
        src={resolveMediaUrl(url)}
        alt={username ? t('userAvatar.usersAvatarAlt', { username }) : t('userAvatar.defaultAvatarAlt')}
        className={`${className} rounded-full object-cover flex-shrink-0`}
      />
    );
  }

  return (
    <div
      className={`${className} rounded-full bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center text-white ${textClass} font-semibold flex-shrink-0`}
    >
      {initial}
    </div>
  );
};

export default UserAvatar;
